export default __webpack_public_path__ + "static/media/msat-passed-modal-vector.3a42eddb.svg";